import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { FormStore } from '../common/form.store';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {

  constructor() { }

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (FormStore.token) {
      const cloned = req.clone({
        headers: req.headers.set('Authorization', 'Bearer ' + FormStore.token)
      });
      return next.handle(cloned);
    } else {
      return next.handle(req);
    }
  }
}
